import { defineComponent as _defineComponent } from 'vue'
import BButton from "JS/components/BButton.vue";
import { BrandBannerWidgetResource } from 'JS/dxp/types/widgets/brand-banner-widget';
import { computed } from 'vue';
import { createPromoDataAttributes } from 'JS/utilities/analytics';
import { normalizeTrailingSlash } from 'JS/utilities/url';
import { useDxpColors } from 'JS/dxp/composables/colors';


export default /*#__PURE__*/_defineComponent({
  __name: 'BrandBannerWidget',
  props: {
    widget: null
  },
  setup(__props: any) {

const props = __props as {
	widget: BrandBannerWidgetResource
}



const { backgroundColor, textColor, bButtonColor } = useDxpColors(() => props.widget.widget.backgroundColor);

const gaDataAttributes = computed(() => !normalizedLink.value ? undefined : createPromoDataAttributes({
	promoId: normalizedLink.value.replace("https://www.farmandfleet.com", ""),
	creativeSlot: "dxp_brand_banner_1",
	creativeName: `dxp_brand_banner_${props.widget.widget.layout}`,
	promoName: `${props.widget.widget.heading}. ${props.widget.widget.subheading}`
}));

const layoutClasses = computed(()=> {
	let classes = "";
	const layouts = props.widget.widget.layout.split('-');

	if (layouts && layouts.length >= 2) {
		if (layouts[0] === "left") {
			classes = "brand-banner-widget--left ";
		}

		if (layouts[1] === "half") {
			classes += "brand-banner-widget--half ";
		}
	}

	return classes;
});

const normalizedLink = computed(() => {
	return normalizeTrailingSlash(props.widget?.widget?.buttonUrl);
});


return { __sfc: true,props, backgroundColor, textColor, bButtonColor, gaDataAttributes, layoutClasses, normalizedLink, BButton }
}

})